import React from "react";
import { Link } from "react-router-dom";
import { Briefcase, MapPin, ArrowRight } from "lucide-react";
import { useSEO, breadcrumbSchema, SITE_URL } from "../lib/seo";

const ROLES = [
  { title: "Support Worker", location: "Melbourne, VIC & Perth, WA", type: "Casual / PT / FT" },
  { title: "Registered Nurse", location: "Melbourne, VIC", type: "Part-time" },
  { title: "Team Leader — SIL", location: "Docklands, VIC", type: "Full-time" },
  { title: "House Manager — SDA", location: "West Perth, WA", type: "Full-time" },
  { title: "Support Coordinator", location: "Melbourne, VIC", type: "Full-time" },
  { title: "Positive Behaviour Support Practitioner", location: "Perth, WA", type: "Full-time" },
];

export default function CareersPage() {
  useSEO({
    title: "NDIS Support Worker & Disability Careers | Melbourne & Perth | Alpha Community Care",
    description: "Join Alpha Community Care — support worker, registered nurse, SIL team leader, SDA house manager and coordinator roles across Melbourne and Perth. Trained, supervised, values-led disability careers.",
    keywords: ["NDIS jobs Melbourne", "disability support jobs Perth", "NDIS careers", "support worker roles", "positive behaviour support jobs"],
    canonical: `${SITE_URL}/careers`,
    jsonLd: [breadcrumbSchema([{ name: "Home", path: "/" }, { name: "Careers", path: "/careers" }])],
  });
  return (
    <div data-testid="page-careers">
      <section className="alpha-gradient-hero border-b border-[color:var(--alpha-line)]">
        <div className="alpha-container pt-14 pb-10">
          <div className="alpha-overline">Careers</div>
          <h1 className="mt-3 text-4xl sm:text-[52px] font-display font-medium tracking-tight leading-[1.05]">Work that genuinely matters.</h1>
          <p className="mt-4 max-w-2xl text-[color:var(--alpha-mute)]">Join a Victoria- and WA-based team of disability professionals who are invested in your training, your career and your wellbeing.</p>
        </div>
      </section>

      <section className="alpha-section">
        <div className="alpha-container">
          <div className="alpha-overline">Open roles</div>
          <h2 className="mt-3 text-3xl font-display font-medium">Currently hiring</h2>
          <div className="mt-8 grid md:grid-cols-2 gap-5">
            {ROLES.map((r) => (
              <div key={r.title} className="alpha-card p-6 flex items-center justify-between gap-4" data-testid={`role-${r.title.toLowerCase().replace(/[^a-z]+/g, "-").slice(0, 30)}`}>
                <div>
                  <div className="flex items-center gap-2">
                    <Briefcase className="w-4 h-4 text-[color:var(--alpha-purple-700)]" />
                    <h3 className="font-display text-lg font-semibold">{r.title}</h3>
                  </div>
                  <div className="mt-1 text-sm text-[color:var(--alpha-mute)] flex items-center gap-3">
                    <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {r.location}</span>
                    <span>·</span>
                    <span>{r.type}</span>
                  </div>
                </div>
                <Link to="/contact" className="alpha-btn-ghost text-sm">Apply <ArrowRight className="w-4 h-4" /></Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
